import {postIssueTournament} from '../api/postIssueTournament';
import { setGetViewTournament } from './setGetViewTournament';

const setPostIssueTournament = (params) => {
    return async (dispatch, getState) => {
        try {
            await postIssueTournament(params);
            dispatch(setGetViewTournament({
                id_tournament: params.id_tournament
            }))
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostIssueTournament
}